import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { LotsSortBy, SortDirection } from '../types/filterAndSort';
/**
 * since the sort won't add or remove entries from the filtered list,
 * we can use a separate store to only "re-organize" the filteredLots on
 * sort state change
 */
const useSortStore = create(subscribeWithSelector((set) => ({
    sortBy: LotsSortBy.Price,
    setSortBy: (sortBy) => {
        set(() => ({ sortBy: sortBy }));
    },
    sortDirection: SortDirection.Ascending,
    setSortDirection: (sortDirection) => {
        set(() => ({ sortDirection: sortDirection }));
    },
})));
export default useSortStore;
